import { Smartphone } from "lucide-react";
import { match } from "ts-pattern";
import { getFilterByFilterName, type FilterCategory } from "../config";
import { createFilterGroup, filterGroupTypes } from "../filter-types";

export const contactFilterCategory = {
  title: "Kontaktinformation",
  id: "contact",
  icon: Smartphone,
  description: "Virksomhedernes kontaktoplysninger",
  filters: {
    adProtected: createFilterGroup({
      id: "ad-protected",
      title: "Reklamebeskyttelse",
      keywords: ["marketingsbeskyttelse", "markedsføringsbeskyttelse"],
      description: "Angiver om virksomhederne er reklamebeskyttede i CVR.",
      filterType: filterGroupTypes.boolean,
      trueLabel: "Er reklamebeskyttede",
      falseLabel: "Er ikke reklamebeskyttede",
      filters: {
        value: {
          fieldName: "commerciallyProtected",
          filterName: "contact-ad-protected",
        },
      },
      DisplayValue: ({ filters }) => {
        const adProtectedFilter = getFilterByFilterName(
          "contact-ad-protected",
          filters,
        );
        if (!adProtectedFilter?.values) return "Ikke angivet";
        if (adProtectedFilter.values[0] === "true") {
          return "Ja";
        }
        return "Nej";
      },
    }),
    liveNumber: createFilterGroup({
      id: "live-number",
      title: "Har Live Nummer",
      keywords: ["tlf", "phone", "telefonnummer"],
      description:
        "Et Live Nummer er et telefonnummer til virksomheden, som ikke er robinson- eller reklamebeskyttet, og som du derfor må ringe til.",
      filterType: filterGroupTypes.checkmark,
      checkLabel: "Har Live Nummer",
      filters: {
        value: {
          fieldName: "LiveNumber.HasLiveNumber",
          filterName: "contact-live-number",
        },
      },
      DisplayValue: ({ filters }) => {
        const liveNumberFilter = getFilterByFilterName(
          "contact-live-number",
          filters,
        );
        const [value = null] = liveNumberFilter?.values || [];
        return value === "true" ? "Ja" : "Ingen betydning";
      },
    }),
    email: createFilterGroup({
      id: "email",
      title: "Har email",
      keywords: ["e-mail", "post"],
      description: "Angiver om virksomheden har en e-mail registreret i CVR",
      filterType: filterGroupTypes.checkmark,
      checkLabel: "Har email",
      filters: {
        value: {
          fieldName: "BasicInfo.Email",
          filterName: "contact-has-email",
        },
      },
      isNullCheck: true,
      DisplayValue: ({ filters }) => {
        const emailFilter = getFilterByFilterName("contact-has-email", filters);
        return match(emailFilter?.operator)
          .with("NotNull", () => "Ja")
          .with("Null", () => "Nej")
          .otherwise(() => "Ikke angivet");
      },
    }),
    website: createFilterGroup({
      id: "website",
      title: "Har website",
      keywords: ["hjemmeside", "webside", "internetside", "url"],
      description:
        "Angiver om virksomheden har en hjemmeside registreret i CVR",
      filterType: filterGroupTypes.checkmark,
      checkLabel: "Har website",
      filters: {
        value: {
          fieldName: "WebsiteData.HasWebsite",
          filterName: "contact-has-website",
        },
      },
      DisplayValue: ({ filters }) => {
        const websiteFilter = getFilterByFilterName(
          "contact-has-website",
          filters,
        );
        if (websiteFilter?.values?.[0] === "true") return "Ja";
        return "Ingen betydning";
      },
    }),
  },
} satisfies FilterCategory;
